import styled from "styled-components";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  /* border-radius: var(--border_radius);
  border-radius: 4px; */
  vertical-align: middle;
  border: 1px solid #e7e7ed;
  box-shadow: inset 0px -1px 0px #e7e7ed;
`;

export const TableHeader = styled.thead`
  border: 1px solid #cdced9;
  color: #643375;
  font-family: "Inter";
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 400;
  border: "2px solid #FBF8FC";
  padding: "2rem";
  height: "4rem";
  height: 48px;
  box-shadow: inset 0px -1px 0px #e7e7ed;
  /* border-radius: 10px; */
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableHeaderCell = styled.th`
  padding: 10px 15px;
  text-align: left;
`;

export const TableCell = styled.td`
  padding: 30px 15px;
  font-family: "Inter";
  /* width:100%; */
`;

export const ActionsIcon = styled.img`
  cursor: pointer;
`;

export const Caption = styled.caption`
  font-size: 1.5rem;
  font-weight: 600;
  padding: 1rem 0;
  margin-bottom: 10px;
  text-align: left;
`;
